var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUitvoeringsOntwerp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 96,
    viewBox: "0 0 76 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 9.75C55.4342 12.9956 56.75 16.9431 56.75 21V24.75H19.25V21C19.25 16.9431 20.5658 12.9956 23 9.75H4.25C3.25544 9.75 2.30161 10.1451 1.59835 10.8484C0.895089 11.5516 0.5 12.5054 0.5 13.5V92.25C0.5 93.2446 0.895089 94.1984 1.59835 94.9017C2.30161 95.6049 3.25544 96 4.25 96H71.75C72.7446 96 73.6984 95.6049 74.4017 94.9017C75.1049 94.1984 75.5 93.2446 75.5 92.25V13.5C75.5 12.5054 75.1049 11.5516 74.4017 10.8484C73.6984 10.1451 72.7446 9.75 71.75 9.75H53Z",
    fill: "#FDC100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 62.25H53",
    stroke: "#445C7A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47.25H53",
    stroke: "#445C7A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 24.75V21C19.25 16.0272 21.2254 11.2581 24.7417 7.74175C28.2581 4.22544 33.0272 2.25 38 2.25C42.9728 2.25 47.7419 4.22544 51.2583 7.74175C54.7746 11.2581 56.75 16.0272 56.75 21V24.75",
    stroke: "#445C7A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUitvoeringsOntwerp);
export default __webpack_public_path__ + "static/media/uitvoerings-ontwerp.3198eca7f5fec977428767f484e9de95.svg";
export { ForwardRef as ReactComponent };